export default __webpack_public_path__ + "static/media/jumga basket logo.b2c853d2.png";